(function () {
  'use strict';
  const root = document.querySelector('[data-product-walkthrough]');
  if (!root) return;
  const tabs = [...root.querySelectorAll('[data-example-tab]')];
  const panels = [...root.querySelectorAll('[data-example-panel]')];
  const tabList = root.querySelector('.pp-example-tabs');
  const workspace = root.querySelector('.pp-example-workspace');
  if (!tabs.length || tabs.length !== panels.length) return;

  const aliases = {
    '#product-capture': 'welcome',
    '#product-context': 'cart',
    '#product-follow-up': 'cart',
    '#product-return': 'return',
    '#product-example': 'cart'
  };
  const status = document.createElement('p');
  status.className = 'pp-screen-reader';
  status.setAttribute('role', 'status');
  workspace.append(status);
  tabList.setAttribute('role', 'tablist');
  tabs.forEach((tab) => tab.setAttribute('role', 'tab'));
  panels.forEach((panel) => panel.setAttribute('role', 'tabpanel'));

  function resetDestination(panel) {
    const message = panel.querySelector('[data-message-view]');
    const destination = panel.querySelector('[data-destination]');
    if (message) message.hidden = false;
    if (destination) destination.hidden = true;
  }

  function selectExample(id, announce) {
    const selected = panels.find((panel) => panel.dataset.examplePanel === id);
    if (!selected) return false;
    panels.forEach((panel) => {
      const active = panel === selected;
      resetDestination(panel);
      panel.hidden = !active;
      panel.toggleAttribute('inert', !active);
      panel.tabIndex = active ? 0 : -1;
    });
    tabs.forEach((tab) => {
      const active = tab.dataset.exampleTab === id;
      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('aria-controls', 'pp-panel-' + tab.dataset.exampleTab);
      tab.tabIndex = active ? 0 : -1;
    });
    if (announce) status.textContent = 'Showing example: ' + tabs.find((tab) => tab.dataset.exampleTab === id).textContent.trim().slice(1).trim() + '.';
    return true;
  }

  function fromHash() {
    const hash = window.location.hash;
    return aliases[hash] || (hash.startsWith('#pp-panel-') ? hash.slice('#pp-panel-'.length) : null);
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', (event) => {
      event.preventDefault();
      selectExample(tab.dataset.exampleTab, true);
    });
    tab.addEventListener('keydown', (event) => {
      let target;
      if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = tabs.length - 1;
      if (event.key === ' ') target = index;
      if (target === undefined) return;
      event.preventDefault();
      selectExample(tabs[target].dataset.exampleTab, true);
      tabs[target].focus({ preventScroll: true });
    });
  });

  root.querySelectorAll('[data-example-link]').forEach((link) => {
    link.addEventListener('click', () => selectExample(link.dataset.exampleLink, true));
  });
  panels.forEach((panel) => {
    const open = panel.querySelector('[data-open-destination]');
    const back = panel.querySelector('[data-back-to-email]');
    const message = panel.querySelector('[data-message-view]');
    const destination = panel.querySelector('[data-destination]');
    if (!open || !back || !message || !destination) return;
    open.addEventListener('click', () => {
      message.hidden = true;
      destination.hidden = false;
      destination.querySelector('h3').focus({ preventScroll: true });
    });
    back.addEventListener('click', () => {
      resetDestination(panel);
      open.focus({ preventScroll: true });
    });
  });
  root.classList.add('pp-ready');
  if (!selectExample(fromHash(), false)) selectExample('cart', false);
  window.addEventListener('hashchange', () => {
    if (fromHash()) selectExample(fromHash(), true);
  });
})();
